/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Tile_NotifyInputs */

const tr_landing_telegram_tile_notify = /** @type {(inputs: Landing_Telegram_Tile_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri bilgilendirme: sipariş SMS'leri ve WhatsApp mesajları otomatik gider.`)
};

const en_landing_telegram_tile_notify = /** @type {(inputs: Landing_Telegram_Tile_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer updates: order SMS and WhatsApp messages go out automatically.`)
};

const de_landing_telegram_tile_notify = /** @type {(inputs: Landing_Telegram_Tile_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundeninformation: Bestell-SMS und WhatsApp-Nachrichten werden automatisch versendet.`)
};

const ru_landing_telegram_tile_notify = /** @type {(inputs: Landing_Telegram_Tile_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления клиентов: SMS о заказе и сообщения в WhatsApp уходят автоматически.`)
};

/**
* | output |
* | --- |
* | "Customer updates: order SMS and WhatsApp messages go out automatically." |
*
* @param {Landing_Telegram_Tile_NotifyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_tile_notify = /** @type {((inputs?: Landing_Telegram_Tile_NotifyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Tile_NotifyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_tile_notify(inputs)
	if (locale === "de") return de_landing_telegram_tile_notify(inputs)
	if (locale === "ru") return ru_landing_telegram_tile_notify(inputs)
	return tr_landing_telegram_tile_notify(inputs)
});